import { Text } from '@/components/Text';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';
import { Image } from './Image';

import cover1Thumb from '@/assets/images/cover-thumbs/1.webp';
import cover10Thumb from '@/assets/images/cover-thumbs/10.webp';
import cover11Thumb from '@/assets/images/cover-thumbs/11.webp';
import cover12Thumb from '@/assets/images/cover-thumbs/12.webp';
import cover13Thumb from '@/assets/images/cover-thumbs/13.webp';
import cover14Thumb from '@/assets/images/cover-thumbs/14.webp';
import cover15Thumb from '@/assets/images/cover-thumbs/15.webp';
import cover16Thumb from '@/assets/images/cover-thumbs/16.webp';
import cover17Thumb from '@/assets/images/cover-thumbs/17.webp';
import cover18Thumb from '@/assets/images/cover-thumbs/18.webp';
import cover19Thumb from '@/assets/images/cover-thumbs/19.webp';
import cover2Thumb from '@/assets/images/cover-thumbs/2.webp';
import cover20Thumb from '@/assets/images/cover-thumbs/20.webp';
import cover21Thumb from '@/assets/images/cover-thumbs/21.webp';
import cover22Thumb from '@/assets/images/cover-thumbs/22.webp';
import cover23Thumb from '@/assets/images/cover-thumbs/23.webp';
import cover24Thumb from '@/assets/images/cover-thumbs/24.webp';
import cover25Thumb from '@/assets/images/cover-thumbs/25.webp';
import cover26Thumb from '@/assets/images/cover-thumbs/26.webp';
import cover27Thumb from '@/assets/images/cover-thumbs/27.webp';
import cover28Thumb from '@/assets/images/cover-thumbs/28.webp';
import cover29Thumb from '@/assets/images/cover-thumbs/29.webp';
import cover3Thumb from '@/assets/images/cover-thumbs/3.webp';
import cover30Thumb from '@/assets/images/cover-thumbs/30.webp';
import cover31Thumb from '@/assets/images/cover-thumbs/31.webp';
import cover32Thumb from '@/assets/images/cover-thumbs/32.webp';
import cover33Thumb from '@/assets/images/cover-thumbs/33.webp';
import cover34Thumb from '@/assets/images/cover-thumbs/34.webp';
import cover35Thumb from '@/assets/images/cover-thumbs/35.webp';
import cover36Thumb from '@/assets/images/cover-thumbs/36.webp';
import cover37Thumb from '@/assets/images/cover-thumbs/37.webp';
import cover38Thumb from '@/assets/images/cover-thumbs/38.webp';
import cover39Thumb from '@/assets/images/cover-thumbs/39.webp';
import cover4Thumb from '@/assets/images/cover-thumbs/4.webp';
import cover40Thumb from '@/assets/images/cover-thumbs/40.webp';
import cover41Thumb from '@/assets/images/cover-thumbs/41.webp';
import cover42Thumb from '@/assets/images/cover-thumbs/42.webp';
import cover43Thumb from '@/assets/images/cover-thumbs/43.webp';
import cover44Thumb from '@/assets/images/cover-thumbs/44.webp';
import cover45Thumb from '@/assets/images/cover-thumbs/45.webp';
import cover46Thumb from '@/assets/images/cover-thumbs/46.webp';
import cover47Thumb from '@/assets/images/cover-thumbs/47.webp';
import cover48Thumb from '@/assets/images/cover-thumbs/48.webp';
import cover49Thumb from '@/assets/images/cover-thumbs/49.webp';
import cover5Thumb from '@/assets/images/cover-thumbs/5.webp';
import cover50Thumb from '@/assets/images/cover-thumbs/50.webp';
import cover6Thumb from '@/assets/images/cover-thumbs/6.webp';
import cover7Thumb from '@/assets/images/cover-thumbs/7.webp';
import cover8Thumb from '@/assets/images/cover-thumbs/8.webp';
import cover9Thumb from '@/assets/images/cover-thumbs/9.webp';

import cover1Full from '@/assets/images/cover-webp/1.webp';
import cover10Full from '@/assets/images/cover-webp/10.webp';
import cover11Full from '@/assets/images/cover-webp/11.webp';
import cover12Full from '@/assets/images/cover-webp/12.webp';
import cover13Full from '@/assets/images/cover-webp/13.webp';
import cover14Full from '@/assets/images/cover-webp/14.webp';
import cover15Full from '@/assets/images/cover-webp/15.webp';
import cover16Full from '@/assets/images/cover-webp/16.webp';
import cover17Full from '@/assets/images/cover-webp/17.webp';
import cover18Full from '@/assets/images/cover-webp/18.webp';
import cover19Full from '@/assets/images/cover-webp/19.webp';
import cover2Full from '@/assets/images/cover-webp/2.webp';
import cover20Full from '@/assets/images/cover-webp/20.webp';
import cover21Full from '@/assets/images/cover-webp/21.webp';
import cover22Full from '@/assets/images/cover-webp/22.webp';
import cover23Full from '@/assets/images/cover-webp/23.webp';
import cover24Full from '@/assets/images/cover-webp/24.webp';
import cover25Full from '@/assets/images/cover-webp/25.webp';
import cover26Full from '@/assets/images/cover-webp/26.webp';
import cover27Full from '@/assets/images/cover-webp/27.webp';
import cover28Full from '@/assets/images/cover-webp/28.webp';
import cover29Full from '@/assets/images/cover-webp/29.webp';
import cover3Full from '@/assets/images/cover-webp/3.webp';
import cover30Full from '@/assets/images/cover-webp/30.webp';
import cover31Full from '@/assets/images/cover-webp/31.webp';
import cover32Full from '@/assets/images/cover-webp/32.webp';
import cover33Full from '@/assets/images/cover-webp/33.webp';
import cover34Full from '@/assets/images/cover-webp/34.webp';
import cover35Full from '@/assets/images/cover-webp/35.webp';
import cover36Full from '@/assets/images/cover-webp/36.webp';
import cover37Full from '@/assets/images/cover-webp/37.webp';
import cover38Full from '@/assets/images/cover-webp/38.webp';
import cover39Full from '@/assets/images/cover-webp/39.webp';
import cover4Full from '@/assets/images/cover-webp/4.webp';
import cover40Full from '@/assets/images/cover-webp/40.webp';
import cover41Full from '@/assets/images/cover-webp/41.webp';
import cover42Full from '@/assets/images/cover-webp/42.webp';
import cover43Full from '@/assets/images/cover-webp/43.webp';
import cover44Full from '@/assets/images/cover-webp/44.webp';
import cover45Full from '@/assets/images/cover-webp/45.webp';
import cover46Full from '@/assets/images/cover-webp/46.webp';
import cover47Full from '@/assets/images/cover-webp/47.webp';
import cover48Full from '@/assets/images/cover-webp/48.webp';
import cover49Full from '@/assets/images/cover-webp/49.webp';
import cover5Full from '@/assets/images/cover-webp/5.webp';
import cover50Full from '@/assets/images/cover-webp/50.webp';
import cover6Full from '@/assets/images/cover-webp/6.webp';
import cover7Full from '@/assets/images/cover-webp/7.webp';
import cover8Full from '@/assets/images/cover-webp/8.webp';
import cover9Full from '@/assets/images/cover-webp/9.webp';

// Create a mapping of all cover images
const coverThumbs = [
  cover1Thumb,
  cover2Thumb,
  cover3Thumb,
  cover4Thumb,
  cover5Thumb,
  cover6Thumb,
  cover7Thumb,
  cover8Thumb,
  cover9Thumb,
  cover10Thumb,
  cover11Thumb,
  cover12Thumb,
  cover13Thumb,
  cover14Thumb,
  cover15Thumb,
  cover16Thumb,
  cover17Thumb,
  cover18Thumb,
  cover19Thumb,
  cover20Thumb,
  cover21Thumb,
  cover22Thumb,
  cover23Thumb,
  cover24Thumb,
  cover25Thumb,
  cover26Thumb,
  cover27Thumb,
  cover28Thumb,
  cover29Thumb,
  cover30Thumb,
  cover31Thumb,
  cover32Thumb,
  cover33Thumb,
  cover34Thumb,
  cover35Thumb,
  cover36Thumb,
  cover37Thumb,
  cover38Thumb,
  cover39Thumb,
  cover40Thumb,
  cover41Thumb,
  cover42Thumb,
  cover43Thumb,
  cover44Thumb,
  cover45Thumb,
  cover46Thumb,
  cover47Thumb,
  cover48Thumb,
  cover49Thumb,
  cover50Thumb,
];

const coverFulls = [
  cover1Full,
  cover2Full,
  cover3Full,
  cover4Full,
  cover5Full,
  cover6Full,
  cover7Full,
  cover8Full,
  cover9Full,
  cover10Full,
  cover11Full,
  cover12Full,
  cover13Full,
  cover14Full,
  cover15Full,
  cover16Full,
  cover17Full,
  cover18Full,
  cover19Full,
  cover20Full,
  cover21Full,
  cover22Full,
  cover23Full,
  cover24Full,
  cover25Full,
  cover26Full,
  cover27Full,
  cover28Full,
  cover29Full,
  cover30Full,
  cover31Full,
  cover32Full,
  cover33Full,
  cover34Full,
  cover35Full,
  cover36Full,
  cover37Full,
  cover38Full,
  cover39Full,
  cover40Full,
  cover41Full,
  cover42Full,
  cover43Full,
  cover44Full,
  cover45Full,
  cover46Full,
  cover47Full,
  cover48Full,
  cover49Full,
  cover50Full,
];

interface CoverGalleryProps {
  onSelectImage: (imageSrc: string) => void;
  totalImages: number;
  imagesPerPage?: number;
}

export const CoverGallery = ({
  onSelectImage,
  totalImages,
  imagesPerPage = 6,
}: CoverGalleryProps) => {
  const { t } = useTranslation();
  const [currentPage, setCurrentPage] = useState(0);
  const totalPages = Math.ceil(totalImages / imagesPerPage);
  const galleryRef = useRef<HTMLDivElement>(null);
  const [touchStartX, setTouchStartX] = useState<number | null>(null);
  const [isSwiping, setIsSwiping] = useState(false);

  const currentPageImages = () => {
    const images = [];
    const startIndex = currentPage * imagesPerPage;
    const endIndex = Math.min(startIndex + imagesPerPage, totalImages);

    for (let i = startIndex; i < endIndex; i++) {
      const imageIndex = i % coverThumbs.length; // Use modulo to handle more images than we have

      images.push({
        id: `cover${i + 1}`,
        src: coverThumbs[imageIndex],
        fullSizeSrc: coverFulls[imageIndex],
        alt: `Cover ${i + 1}`,
      });
    }

    return images;
  };

  const goToNextPage = () => {
    setCurrentPage(prev => (prev + 1) % totalPages);
  };

  const goToPrevPage = () => {
    setCurrentPage(prev => (prev - 1 + totalPages) % totalPages);
  };

  // Gestion des événements tactiles pour le défilement horizontal
  const handleTouchStart = (e: React.TouchEvent) => {
    setTouchStartX(e.touches[0].clientX);
    setIsSwiping(true);
  };

  const handleTouchMove = () => {
    // Pas besoin de faire quoi que ce soit pendant le mouvement
  };

  const handleTouchEnd = (e: React.TouchEvent) => {
    if (!touchStartX || !isSwiping) return;

    const touchEndX = e.changedTouches[0].clientX;
    const diff = touchStartX - touchEndX;

    // Seuil de défilement (en pixels)
    const threshold = 50;

    if (diff > threshold) {
      // Swipe vers la gauche, page suivante
      goToNextPage();
    } else if (diff < -threshold) {
      // Swipe vers la droite, page précédente
      goToPrevPage();
    }

    setTouchStartX(null);
    setIsSwiping(false);
  };

  return (
    <div
      ref={galleryRef}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
      className="touch-manipulation"
    >
      <div className="mb-4 flex items-center justify-between">
        <Text className="text-base font-medium text-linko-dark">
          {t('updateCard:images.selectFromGallery')}
        </Text>
        <div className="flex flex-col items-end">
          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={goToPrevPage}
              className="flex size-8 items-center justify-center rounded-full bg-gray-100 text-gray-600 transition-colors hover:bg-gray-200"
              aria-label="Page précédente"
            >
              <BsChevronLeft className="size-4" />
            </button>
            <Text className="text-sm text-gray-600">
              {currentPage + 1} / {totalPages}
            </Text>
            <button
              type="button"
              onClick={goToNextPage}
              className="flex size-8 items-center justify-center rounded-full bg-gray-100 text-gray-600 transition-colors hover:bg-gray-200"
              aria-label="Page suivante"
            >
              <BsChevronRight className="size-4" />
            </button>
          </div>
          {totalPages > 1 && (
            <Text className="mt-1 text-xs italic text-gray-400 md:hidden">
              {t('updateCard:images.swipeToNavigate', 'Glissez pour naviguer')}
            </Text>
          )}
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4 md:grid-cols-3">
        {currentPageImages().map(image => (
          <div
            key={image.id}
            onClick={() => onSelectImage(image.fullSizeSrc)}
            className="group relative aspect-video cursor-pointer overflow-hidden rounded-lg border-2 border-transparent transition-all duration-200 hover:border-linko-light hover:shadow-md"
          >
            <div className="absolute inset-0 flex items-center justify-center">
              <Image
                src={image.src}
                alt={image.alt}
                className="size-full object-cover transition-transform duration-300 group-hover:scale-105"
              />
            </div>
            <div className="absolute inset-0 hidden items-center justify-center bg-black/0 transition-colors duration-300 group-hover:bg-black/40 md:flex">
              <Text className="px-4 py-2 text-center text-white opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                {t('updateCard:images.chooseAsCover')}
              </Text>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
